import React, {useState} from 'react'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import {isMobile, resolveErrorMessage} from '../../../../utils/utils'
import {setLogin} from '../../../../actions/authActions'
import {Button, Form, Message} from 'semantic-ui-react'
import STRATEGIC_PARTNER from "../../../../constants/strategicPartners";
import {SupportEmailLink} from "../../../common";
import {CustomContainer, CustomDivider, CustomEmailInput} from '../../../custom-common'

export const LoginForm = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const isResetPasswordFlow = useSelector(state => state.mobile.isResetPasswordFlow);

  const handleChange = e => {
    const { name, value } = e.target

    setForm(form => ({ ...form, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (loading) return

    setError(null)

    const { email, password } = form

    if (!email) return setError('Please enter your email address')
    if (!password) return setError('Please enter your password')

    setLoading(true)

    try {
      const { data } = await axios.post('/api/member/v2/login', {
        email: email.trim(),
        password: password
      })

      const {
        employerName: username,
        redirectAuthenticated,
        step,
        ...auth
      } = data

      if (redirectAuthenticated) return window.location = redirectAuthenticated;

      const loginData = {
          ...auth,
          username,
      }
      dispatch(setLogin(loginData))
      if (isResetPasswordFlow && isMobile()) {
        history.push('/betterOnTheApp');
      } else {
        history.push('/plan');
      }
    } catch (e) {
      setError(resolveErrorMessage(e, 'An unexpected error has occurred.'))
      setLoading(false)
    }
  }

  return (
    <CustomContainer basic className={'noPadding'} loading={loading}>
      {error && <Message error>{error}</Message>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <CustomEmailInput
            width={12}
            name='email'
            value={form.email || ''}
            onChange={handleChange}
            disabled={loading}
          />
        </Form.Group>
          <Form.Input
            label={'Password'}
            type='password'
            name='password'
            value={form.password || ''}
            onChange={handleChange}
            disabled={loading}
          />
        <CustomDivider small hidden/>
          <Button primary fluid disabled={loading}>Sign in</Button>
      </Form>
      <CustomDivider small hidden/>
          <Link className={'small'} to='/forgotPassword'>Forgot password?</Link>
      <CustomDivider small hidden/>
      {error && <p className='loginErrorMessage smaller'>Still need help? Reach out to our technical support team at<br/>{STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER} or <SupportEmailLink /></p>}
    </CustomContainer>
  )
}

export default LoginForm
